var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7899 0H6.21008C4.624 0 3.33333 1.29067 3.33333 2.87675V3.33333H2.87675C1.29067 3.33333 0 4.624 0 6.21008V13.7898C0 15.376 1.29067 16.6667 2.87675 16.6667H10.4565C11.9136 16.6667 13.1083 15.5735 13.2952 14.1667H13.7898C15.376 14.1667 16.6667 12.876 16.6667 11.2899V2.87675C16.6667 1.29067 15.376 0 13.7899 0ZM15 11.2899C15 11.9572 14.4572 12.5 13.7899 12.5H13.3333V6.21008C13.3333 4.624 12.0427 3.33333 10.4566 3.33333H5V2.87675C5 2.2095 5.54283 1.66667 6.21008 1.66667H13.7898C14.4572 1.66667 15 2.2095 15 2.87675V11.2899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.6640fc1c296af9475157f12ed3094f2e.svg";
export { ForwardRef as ReactComponent };